import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "404",
  height: "404",
  fill: "none",
  viewBox: "0 0 404 404"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#E3E3E3",
      d: "M59.879 306.46c10.989 26.815 28.906 32.397 41.503 26.815 24.363-10.794 87.649-22.855 152.646 5.494 86.085 37.548 104.401-19.101 76.927-76.404s-36.786-115.251-5.114-147.177c31.673-31.927-9.774-81.87-83.378-29.882-47.566 33.597-82.474 26.116-101.219 16.618-17.667-8.951-37.315-18.31-55.723-11.003-22.336 8.867-31.137 28.089 2.847 71.033 48.157 60.855-53.122 84.4-28.49 144.506"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B9BABB",
      d: "M104.622 175.833h171.019v131.524a1.013 1.013 0 0 1-1.01 1.01H105.632a1.01 1.01 0 0 1-1.01-1.01z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#5E5E5E",
      d: "M232.738 124.292h-79.52l-48.596 51.54h171.019z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#888",
      d: "m120.82 103.675 32.397 20.616-48.595 51.541-36.815-27.979zM265.135 103.675l-32.397 20.616 42.903 51.541 42.507-27.979zM174.109 104.729a3.92 3.92 0 0 0 1.931-5.074l-14.574-34.366a3.925 3.925 0 0 0-5.291-2.012l-2.808 1.331a3.93 3.93 0 0 0-2.04 2.303 3.92 3.92 0 0 0 .25 3.067l17.382 33.034a3.92 3.92 0 0 0 5.15 1.717M192.381 101.398a2.57 2.57 0 0 0 2.388-2.64l-.72-24.466a2.567 2.567 0 0 0-2.753-2.49l-2.032.146a2.575 2.575 0 0 0-2.281 1.827c-.099.332-.131.681-.092 1.025l2.753 24.321a2.57 2.57 0 0 0 2.737 2.277M206.487 110.442c1.82 1.052 4.375.086 5.792-2.19l25.162-40.41c1.503-2.415 1.147-5.357-.783-6.473l-2.691-1.555c-1.93-1.117-4.658.043-6 2.55l-22.472 41.965c-1.265 2.364-.828 5.06.992 6.113"
    }, null, -1)
  ]))]))
}
export default { render: render }